import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';

const ENCODED_ROUTES: RegExp[] = [
  /\/api\/internal\/regulatory-updates$/,
  /\/api\/internal\/regulatory-updates\/[^/]+$/,
];

function needsEncoding(req: HttpRequest<unknown>): boolean {
  if (req.method !== 'POST' && req.method !== 'PUT') return false;
  return ENCODED_ROUTES.some(pattern => pattern.test(req.url));
}

export const bodyEncodingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!needsEncoding(req)) return next(req);

  const encoded = encodeURIComponent(JSON.stringify(req.body));

  const encodedReq = req.clone({
    body: encoded,
    setHeaders: {
      'Content-Type': 'text/plain',
      'X-Body-Encoding': 'uri',
    },
  });

  return next(encodedReq);
};
